// frontend/src/pages/Dashboard.js
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import { useAuth } from '../context/AuthContext';
 
const SECTIONS = [
  { key: 'ai',    label: 'AI Workloads',          emoji: '🤖', color: '#1E3A5F' },
  { key: 'ml',    label: 'Machine Learning',       emoji: '📊', color: '#1A6B3A' },
  { key: 'cv',    label: 'Computer Vision',        emoji: '👁️', color: '#C05000' },
  { key: 'nlp',   label: 'Natural Language',       emoji: '💬', color: '#4A1A6B' },
  { key: 'genai', label: 'Generative AI',          emoji: '✨', color: '#8B0000' },
  { key: 'all',   label: 'All Questions (400)',    emoji: '🎯', color: '#2C2C2C' },
];
 
export default function Dashboard() {
  const { user } = useAuth();
  const navigate = useNavigate();
 
  async function handleSignOut() {
    await supabase.auth.signOut();
    navigate('/login');
  }
 
  return (
    <div style={{ maxWidth: '900px', margin: '0 auto', padding: '40px 20px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '32px' }}>
        <h1 style={{ color: '#1E3A5F' }}>AI-901 Exam Prep 🎓</h1>
        <div>
          <span style={{ marginRight: '16px', color: '#555' }}>{user?.email}</span>
          <button onClick={handleSignOut} style={{ padding: '8px 16px', cursor: 'pointer' }}>
            Sign Out
          </button>
        </div>
      </div>
 
      <p style={{ color: '#555', marginBottom: '32px', fontSize: '18px' }}>
        Choose a section to start practicing. First 10 questions are <strong>free!</strong>
      </p>
 
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: '20px' }}>
        {SECTIONS.map(s => (
          <div key={s.key}
            onClick={() => navigate(`/quiz/${s.key}`)}
            style={{
              background: s.color, color: '#fff', padding: '32px 24px',
              borderRadius: '16px', cursor: 'pointer', transition: 'transform 0.2s',
              boxShadow: '0 4px 16px rgba(0,0,0,0.15)'
            }}
            onMouseOver={e => e.currentTarget.style.transform = 'translateY(-4px)'}
            onMouseOut={e => e.currentTarget.style.transform = 'translateY(0)'}
          >
            <div style={{ fontSize: '48px', marginBottom: '12px' }}>{s.emoji}</div>
            <div style={{ fontSize: '20px', fontWeight: 'bold' }}>{s.label}</div>
            <div style={{ marginTop: '8px', opacity: 0.8 }}>
              {s.key === 'all' ? '400 questions' : '80 questions'}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
